















import { Row, Col } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {
    "van-row": Row,
    "van-col": Col
  }
})
export default class NewsMultiple extends Vue {
  @Prop()
  private imgMoreList: any;
  @Prop()
  private num: number | undefined; //横屏竖屏的个数竖屏是12  横屏是8
  @Prop()
  private isApp: boolean | undefined;
  mounted() {
    if (this.isApp) {
      let box = document.getElementsByClassName("isapp")[0] as any;
      let width = document.documentElement.clientWidth / 46;
      let height = document.documentElement.clientHeight / 62;
      console.log(width + " " + height);
      let i = width / height;
      box.style.width = height * 1.1 + "rem";
      box.style.height = width * 1.1 + "rem";
      box.style.top = (height - width) / i / 2.6 + "rem";
      box.style.left = 0 - (height - width) / i / 1.3 + "rem";
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        box.style.left = 0 - (height - width) / i / 0.8 + "rem";
      }
    }
  }
  intoNews(item: any) {
    this.$router.push({
      path: "/multiple/news-multiple",
      query: {
        id: item.id
      }
    });
  }
}
